module.exports = __webpack_public_path__ + "static/media/upper-right-arrow.527b2b7d.svg";